import { useEffect } from "react";
import { setToLocalStorage } from "core/utils/utils.helper";
import { IPHONE_SPECIFIC_IOS_TOKEN } from "constants/general";

const useIOSFCMToken = () => {
  useEffect(() => {
    window.receiveFCMToken = async (token: string) => {
      if (!token) {
        console.warn("Received empty or invalid FCM token");
        return;
      }
      console.log("Received FCM Token from iOS:", token);
      setToLocalStorage(IPHONE_SPECIFIC_IOS_TOKEN, token);
    };
    return () => {
      delete window.receiveFCMToken;
    };
  }, []);
};

export default useIOSFCMToken;
